import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { Forgot } from "../../../api";
import PhoneInputW from "../../../Reservation/PhoneInput";
import { useTranslation } from "../../../../context/TranslationContext";

const ForgotStepPhone = ({ onNext }) => {
  const {
    sendResetCode,
    phone: phoneLabel,
    phoneRequired,
    operationFailed,
  } = useTranslation();

  const Step1Schema = Yup.object().shape({
    phoneNumber: Yup.string().required(phoneRequired),
  });

  const handleSubmit = async (values, actions) => {
    try {
      const response = await Forgot({ phoneNumber: values.phoneNumber }, 1);
      if (response.data.error) {
        toast.error(response.data.error);
      } else {
        onNext(values.phoneNumber);
      }
    } catch (error) {
      toast.error(operationFailed);
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={{ phoneNumber: "" }}
      validationSchema={Step1Schema}
      onSubmit={handleSubmit}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit}>
          <div className="relative z-0 mb-6 w-full group h-[60px]">
            <PhoneInputW
              label={phoneLabel}
              validname="phoneNumberValid"
              isrequired="required"
              name="phoneNumber"
              mode="simple"
            />
          </div>
          <button
            disabled={props.isSubmitting}
            type="submit"
            className="text-white w-full px-8 py-4 duration-200 bg-product-type-color hover:opacity-90 font-medium rounded-lg text-sm text-center mb-5 disabled:opacity-60"
          >
            {sendResetCode}
          </button>
        </form>
      )}
    </Formik>
  );
};

export default ForgotStepPhone;
